import React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { clearCart } from '../../redux/slices/cartSlice';

const Success = () => {
    const dispatch = useDispatch()
    useEffect(()=>{
        dispatch(clearCart())
    },[dispatch])
    return (
        <div className='container mx-auto px-5 lg:px-0 py-20 text-center'>
            <p className='text-4xl font-semibold'>Congratulations</p>
            <h2 className='text-2xl mt-5'>Order Success</h2>
            <p>Thanks for your Order.</p>
            <p>Track your order here : <Link className='underline' to='/my-order'>Check Order</Link></p>
        </div>
    );
};

export default Success;